import { Layout } from "../components/Layout";
import { CreateProperty } from "../modules/properties/templates/create-property";

const PageCreateProperty = () => (
  <Layout>
    <CreateProperty />
  </Layout>
);

export default PageCreateProperty;
